import { Button } from "@appcharge/shared-ui";
import { ColumnDef } from "@tanstack/react-table";
import dayjs from 'dayjs';
import { formatDateTimeByLocale } from "utils/formattingUtil";

import { cn } from "components/lib/utils";
import { TableCellEllipsis } from "components/Orders/Orders/Components/TableCellEllipsis";

import { EReportStatus, ReportTableRow } from "../types";

// TODO (This is a TEMPORARY SOLUTION until we will implement a proper Status Badge component in the design system / ACDEV-18452)
const ReportStatusBadge = ({ status }: { status: EReportStatus }) => {
  const statusConfig: Record<EReportStatus, { label: string; colors: string; background?: string }> = {
    [EReportStatus.CREATED]: {
      label: 'Done',
      colors: 'text-green-500',
      background: 'rgba(34, 197, 94, 0.20)'
    },
    [EReportStatus.IN_PROGRESS]: {
      label: 'Processing',
      colors: 'text-orange-500 bg-orange-50'
    },
    [EReportStatus.FAILED]: {
      label: 'Failed',
      colors: 'text-rose-600 bg-rose-50'
    }
  };

  const config = statusConfig[status];

  if (!config) {
    return <div>Unknown Status: {status}</div>;
  }

  return (
    <div
      className={cn(
        'rounded-full px-2 py-1.5 text-p-xs flex justify-center items-center max-w-fit',
        config.colors
      )}
      style={config.background ? { background: config.background } : undefined}
    >
      {config.label}
    </div>
  );
};

export const FINANCIAL_REPORTS_TABLE_COLUMNS = (
  onDownloadClick: (reportId: string) => void
): ColumnDef<ReportTableRow>[] => [
    {
      accessorKey: 'dateCreated',
      header: 'Date Created',
      cell: ({ getValue }) => <TableCellEllipsis>{formatDateTimeByLocale(getValue() as string)}</TableCellEllipsis>,
      enableSorting: true,
      sortDescFirst: true
    },
    {
      accessorKey: 'project',
      header: 'Project',
      cell: ({ getValue }) => <TableCellEllipsis>{getValue() as string}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'startDate',
      header: 'Start',
      cell: ({ getValue }) => <TableCellEllipsis>{dayjs(getValue() as string).format('MMM DD, YYYY')}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'endDate',
      header: 'End',
      cell: ({ getValue }) => <TableCellEllipsis>{dayjs(getValue() as string).format('MMM DD, YYYY')}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'status',
      header: 'Status',
      cell: ({ getValue }) => {
        const status = getValue() as EReportStatus;
        return <ReportStatusBadge status={status} />;
      },
      enableSorting: true
    },
    {
      accessorKey: 'reportId',
      header: 'Download Report',
      cell: ({ row }) => {
        const isDisabled = row.original.status !== EReportStatus.CREATED;
        return (
          <Button
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              if (!isDisabled) {
                onDownloadClick(row.original.reportId);
              }
            }}
            disabled={isDisabled}
          >
            Download
          </Button>
        );
      }
    },
  ];

export const REPORT_TABLE_ROWS_PER_PAGE = 200;

